import { render, staticRenderFns } from "./LiveJiuxiao.vue?vue&type=template&id=2ac1ea87&scoped=true&"
import script from "./LiveJiuxiao.vue?vue&type=script&lang=js&"
export * from "./LiveJiuxiao.vue?vue&type=script&lang=js&"
import style0 from "./LiveJiuxiao.vue?vue&type=style&index=0&id=2ac1ea87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac1ea87",
  null
  
)

export default component.exports